import ReactDOM from "react-dom";
import { Button, Modal, ModalBody } from "reactstrap";
import styles from "./ConfirmDialog.module.scss";
import { AiOutlineClose } from "react-icons/ai";

function DialogBody({
  visible,
  toggle,
  activeBtnClick,
  bodyStyle = {},
  size = "sm",
  showButton = true,
  showCloseBtn = true,
  modalStyles = {},
  backdrop = "static",
  backdropClassName,
  ...props
}) {
  const resolvedBackdropClass =
    backdropClassName && styles[backdropClassName]
      ? styles[backdropClassName]
      : backdropClassName;

  return (
    <div className={styles.ModalDialog}>
      <Modal
        toggle={toggle ? toggle : null}
        isOpen={visible}
        size={size}
        style={modalStyles}
        onClick={props.onClick}
        centered
        modalClassName={`${styles.confirmBox} ${props.modalClassName || ""}`}
        wrapClassName={`${styles.confirmBox} ${
          props.wrapClassName || props.modalClassName || ""
        }`}
        contentClassName={`${styles.contentBox} ${props.contentClassName || ""}`}
        backdrop={backdrop as any}
        backdropClassName={resolvedBackdropClass}
      >
        <ModalBody className={`${styles.body} ${props.bodyClassName || ""}`}>
          {showCloseBtn && (
            <div className={styles.closeButton} onClick={() => toggle()}>
              <AiOutlineClose />
            </div>
          )}
          <div style={bodyStyle}>
            {props.children}

            {props.title ? (
              <div className={`${styles.title} ${props.error ? "error" : ""}`}>
                {props.title}
              </div>
            ) : null}
            {props.subTitle ? (
              <div
                className={`${styles.subTitle} ${props.error ? "error" : ""}`}
              >
                {props.subTitle}
              </div>
            ) : null}
            {showButton && (
              <div className={styles.buttonBlock}>
                <Button
                  className={`${styles.button} ${props.closeBtnClassName}`}
                  onClick={(e) => {
                    toggle();
                  }}
                >
                  Cancel
                </Button>
                <Button
                  className={`${styles.button} ${styles.btnOk}`}
                  onClick={(e) => {
                    activeBtnClick();
                    toggle();
                  }}
                >
                  {props.activeBtn ? props.activeBtn : "Yes"}
                </Button>
              </div>
            )}
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

const ConfirmDialog = (props) =>
  props.visible
    ? ReactDOM.createPortal(DialogBody(props), document.body)
    : null;

export default ConfirmDialog;
